/** Every word the Djinn chat panel shows. Nothing here names an id, an enum value or a field. */

export const DJINN_NAME = "Djinn";

export const DJINN_SHORTCUT = "⌘J";

export const DJINN_SENDING = "Sending";
export const DJINN_SEND_FAILED =
  "That did not send. Your message is still here, so you can send it again.";
export const DJINN_RETRY = "Send again";

export const djinnStepAnnounce = (words: string) => `Djinn is now: ${words}`;

export const djinnWindow = (days: number, players: number | undefined) =>
  `${days} ${days === 1 ? "day" : "days"}${players === undefined ? "" : ` · ${players.toLocaleString("en")} ${players === 1 ? "player" : "players"}`}`;

/** The words under a headline's figures, by the metric code named; an unknown metric is said plainly. */
const METRIC_WORDS: Record<string, string> = {
  earned_per_spent: "earned per spent",
  earned: "earned",
  spent: "spent",
  net: "net",
  days_to_cap: "days until full",
  stat_drift: "drift a day",
  retention: "return",
  day_seven_return: "day seven return",
  day_one_return: "day one return",
  nitro_price: "nitro price now",
};
export const djinnMetricWords = (metric: string): string =>
  METRIC_WORDS[metric] ?? DJINN_METRIC_FALLBACK;

export const djinnCostWords = (charge: string, credits: number | undefined): string =>
  charge === "free"
    ? "free"
    : charge === "not_charged"
      ? "Not charged"
      : `${credits ?? 0} ${credits === 1 ? "credit" : "credits"}`;

export const DJINN_VIEW_ONLY_CARD = "View-only. An owner, admin or developer can fix and save.";
export const djinnWhyNot = (code: string | null | undefined): string | null =>
  code === "view_only"
    ? DJINN_VIEW_ONLY_CARD
    : code === "released"
      ? "already released"
      : code === "expired"
        ? "too old to save"
        : code === "production_plays_draft"
          ? "Production plays your draft"
          : code === "draft_moved"
            ? "the draft has moved"
            : code === "not_starter"
              ? DJINN_ONLY_STARTER
              : code === "credits"
                ? DJINN_WHY_CREDITS
                : code === "paused"
                  ? DJINN_WHY_PAUSED
                  : null;

export const djinnSavedBy = (by: string) => `Saved by ${by}`;
export const DJINN_NOT_SAVED = "Not saved";
export const djinnNotSavedBy = (by: string, when: string) => `${by} · ${when}`;

export const djinnCantReach = (goal: string, better: "lower" | "higher" = "lower") =>
  `Can’t reach ${better === "higher" ? "over" : "under"} ${goal}`;
export const DJINN_TIMED_OUT_TITLE = "Couldn’t finish in 3 minutes";
export const DJINN_FAILED_TITLE = "Couldn’t finish";
export const DJINN_NOTHING_TITLE = "Nothing worth changing";

export const DJINN_CB_HELD = "Held";
export const DJINN_CB_DIDNT = "Didn’t hold";
export const DJINN_CB_EARLY = "Early read";
export const DJINN_CB_RIGHT = "Did this match what you saw?";
export const DJINN_CB_THANKS = "Thanks, that helps me read the next one.";

export const DJINN_METRIC_FALLBACK = "your goal";
export const DJINN_WHY_CREDITS = "Not enough credits left this month";
export const DJINN_WHY_PAUSED = "Djinn is paused for this game";
export const DJINN_ONLY_STARTER = "Only the person who started this or an admin can stop it.";
